import { useEffect } from 'react'
import styled from 'styled-components'

import AccountLinks from './AccountLinks'
import UnstyledLogo from './Logo'
import NavigationBar from './NavigationBar'
import NotificationBar from './NotificationBar.js'
import Search from './Search'

const Header = styled.header`
  margin: 0 10px;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  max-width: 100%;
  min-height: 45px;
  min-width: 383px;
  border-bottom: 3px solid #68504c;
  font-size: 13px;
  line-height: 1.4em;
  font-family: arial, verdana, tahoma, helvetica, sans-serif;
`

const Logo = styled(UnstyledLogo)`
  height: 66px;
  margin: 0 5px;
  flex-basis: 65px;
  display: inline-block;
`

const Wrapper = styled.div`
  flex: 1 1 auto;
`

const Account = styled.div`
  text-align: right;
`

const SearchWrapper = styled.div`
  display: flex;
`

const AllItems = styled.a`
  margin: 0 0 0 5px;
  padding: 6px 8px 2px 8px;
  font-size: 14px;
  min-width: 70px;
  height: 32px;
  display: inline-block;
  text-decoration: none;
  transition: background-color 0.3s;
  border-radius: 3px;
  background-color: #d6d0c7;
  color: #361611;
  vertical-align: middle;
  line-height: 1.42857143;
  user-select: none;

  :hover {
    background-color: #361611;
    color: white;
    text-decoration: none;
  }
`

const NotificationsApp = styled.span`
  min-width: 36px;
  min-height: 36px;
  margin-left: 2px;
  font-size: 20px;
`

export default ({ handleEquipmentAccordion }) => {
  useEffect(() => {
    const attach = window.attachNotifications
    const render = window.renderNotifications

    if (attach && render) {
      attach('notifications')
      render('notifications')
    }
  }, [])

  return (
    <Header>
      <Logo id='header_logo' />
      <Wrapper>
        <Account>
          <NotificationBar />
          <AccountLinks />
        </Account>
        <SearchWrapper>
          <NavigationBar handleEquipmentAccordion={handleEquipmentAccordion} />
          <Search />
          <AllItems id='header_all_items' href='/search'>
            All Items
          </AllItems>
          <NotificationsApp id='notifications' />
        </SearchWrapper>
      </Wrapper>
    </Header>
  )
}
